import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {setter} from "../utils/setter";
import {Notify} from "../../hooks/system/useNotify";

export enum SWStatus {
  INSTALLING,
  WAITING,
  ACTIVE
}

export enum ThemeMode {
  DARK,
  LIGHT
}

export interface SystemState {
  status?: SWStatus,
  sw?: ServiceWorker,
  fetching: number,
  themeMode?: ThemeMode,
  notifies: Notify[],
  logo?: string
  backendOnline?: boolean
}

const initialState: SystemState = {
  fetching: 0,
  notifies: [],
  backendOnline: true
};

export const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setStatus: setter(initialState, 'status'),
    setSW: setter(initialState, 'sw'),
    setThemeMode: setter(initialState, 'themeMode'),
    setNotifies: setter(initialState, 'notifies'),
    addNotifies: (s: SystemState, a:PayloadAction<Notify>) => {
      s.notifies = [...s.notifies, a.payload]
    },
    inc: state => {
      state.fetching += 1
    },
    dec: state => {
      state.fetching -= 1
    },
    setLogo: setter(initialState, 'logo'),
    setBackendOnline: setter(initialState, 'backendOnline')
  }
});
